import React from 'react'
import "./components.css"
import { useSelector } from 'react-redux'
import moment from 'moment/moment'

const Message = ({ message, currentUserId }) => {

    const userIdFromStore = useSelector((state) => state.auth?.user?.user?._id)
    const userId = currentUserId || userIdFromStore

    return (
        <div className={userId && userId === message.sender ? "sent-msg" : "received-msg"}>
            <div className="msg-container">
                <div className="msg-text">
                    <p>{message.message}</p>
                </div>
                <div className="time">
                    <p>{moment(message.createdAt).format("DD/MM/YYYY HH:mm")}</p>
                    <p>{message.sentStatus}</p>
                </div>
            </div>
        </div>
    )
}

export default Message